<ng-container [appPreloader]="[endpoints.PROPERTIES_CATEGORIES_MOVEMENTS_GET]" [preloaderType]="preloaderTypes.OVERLAY"></ng-container>
@if (form) {
  <form [formGroup]="form" [class.transparent]="isTransparent" appFormErrorScroll>
    <div class="row">
      <!-- Income input -->
      @if (showFinancialYear) {
        <div class="col-12 col-md-6">
          <mat-form-field>
            <mat-label>Financial Year</mat-label>
            <input matInput
              placeholder="Financial Year"
              formControlName="financialYear"
              [disabled]="true"
              required>
            </mat-form-field>
          </div>
        }
        <!-- Income input -->
        @if (form.get('income').enabled) {
          <div class="col-12 col-md-6">
            <app-currency-input min="0"
              inputId="onBoardingPropertyRentalIncAdd"
              formControlName="income"
              label="Rental Income"
              placeholder="Enter annual Income">
            </app-currency-input>
          </div>
        }
        <!-- Expenses input -->
        <div class="col-12 col-md-6">
          <app-currency-input min="0"
            inputId="onBoardingPropertyRentalExpAdd"
            formControlName="expense"
            [label]="expenseLabel"
            placeholder="Enter annual Expenses">
          </app-currency-input>
        </div>
        <!-- Interest input -->
        <div class="col-12 col-md-6">
          <app-currency-input min="0"
            inputId="onBoardingPropertyRentalLoanAdd"
            formControlName="interest"
            [label]="interestLabel"
            placeholder="Enter annual Interest">
          </app-currency-input>
        </div>
        <!-- Depreciation input -->
        @if (form.get('depreciation').enabled) {
          <div class="col-12 col-md-6">
            <app-currency-input min="0"
              inputId="onBoardingPropertyRentalDepAdd"
              formControlName="depreciation"
              label="Rental Depreciation"
              placeholder="Enter annual Depreciation">
            </app-currency-input>
          </div>
        }
        <!-- ClaimPercent input -->
        @if (form.get('claimPercent').enabled) {
          <div class="col-12 col-md-6">
            <app-property-claim-percentage-calculator [form]="form"></app-property-claim-percentage-calculator>
          </div>
        }
      </div>
    </form>
  }
